import './BetbookModule.less';

import React, { memo, useLayoutEffect } from 'react';
import { dispatchSync } from 'nike-re-framejs';

import i18n from '@i18n';
import IntersectionObserver from '@/ui/IntersectionObserver';
import Loadable from '@/common/lazy/Loadable';
import imports from '@/routing/imports';
import useBoxStore from '@/nikeone/hook/useBoxStore';
import { BETBOOK } from '@/nikeone/context/BoxOptionsContext';
import {
    COMMUNITY_ANALYSES,
    COMMUNITY_ANALYSIS_DETAIL,
    COMMUNITY_LOBBY,
    COMMUNITY_TICKET_DETAIL,
    BETBOOK_TICKETS
} from '@/routing/routes';
import { navigate } from '@/routing';
import PageModule from '@/common/components/page-module/PageModule';
import { clearBetbook } from '@/betbook/handlers';
import { useActiveRoute } from 'nike-ui/src/common/routing/NikeRouteContext';
import BetLocationContext, { betLocation } from 'nike-ui/src/common/BetLocationContext';
import { POST_ANALYSIS } from 'nike-ui/src/components/betbook/constants';

const BetbookModuleLoader = Loadable({ loader: imports.betbook, exp: Exp => Exp.HomePageBetbookPosts });

function handleShowMore(e) {
    e.preventDefault();
    dispatchSync(clearBetbook);
    navigate(COMMUNITY_ANALYSES);
}

function BetbookModule({ visible }) {
    const route = useActiveRoute();

    useLayoutEffect(() => {
        if (
            route !== COMMUNITY_ANALYSES ||
            route !== BETBOOK_TICKETS ||
            route !== COMMUNITY_LOBBY ||
            route !== COMMUNITY_ANALYSIS_DETAIL ||
            route !== COMMUNITY_TICKET_DETAIL
        ) {
            return () => dispatchSync(clearBetbook);
        }
    });

    useBoxStore('betbook', BETBOOK);

    return (
        <BetLocationContext.Provider value={{ betLocationSection: betLocation.HP_BETBOOK }}>
            <div className="module-separator" />
            <PageModule
                className="betbook"
                title={i18n('homepage.userPosts')}
                link={i18n('common.terms.all')}
                onClick={handleShowMore}
            >
                {visible && <BetbookModuleLoader homepagePosts postType={POST_ANALYSIS} />}
                <button className="module-show-more" onClick={handleShowMore} data-atid="hp-show-moreAnalyses">
                    {i18n('common.show.all')}
                </button>
            </PageModule>
        </BetLocationContext.Provider>
    );
}

export const IOBetbookModule = memo(function IOBetbookModule() {
    return <IntersectionObserver>{visible => <BetbookModule visible={visible} />}</IntersectionObserver>;
});
